var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"mc-radio",class:{
        'is-disabled': _vm.disabled
    }},[_c('span',{staticClass:"mc-radio__input"},[_c('span',{staticClass:"mc-radio__inner",class:{
            'is-checked': !!_vm.currentValue,
            'is-disabled': _vm.disabled
        }}),_vm._v(" "),_c('input',{staticClass:"mc-radio__original",attrs:{"type":"radio","name":_vm.groupName},domProps:{"checked":_vm.currentValue},on:{"change":_vm.change}})]),_vm._v(" "),_c('span',{staticClass:"mc-radio__label",class:{
        'is-disabled': _vm.disabled
    }},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


// WEBPACK FOOTER //
// ./src/components/base-radio.vue